import React, { Fragment, useState } from 'react'
import Markdown from 'react-markdown'
import styled from 'react-emotion'
import { Modal } from '../../application'
import { textBuilder } from '../../resources'
import getText from '../strings'
import HotelContactDetails from './HotelContactDetails'
import moment from 'moment'
import LocalizedCurrency from '../../application/components/LocalizedCurrency'

const Flex = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media (max-width: 992px) {
    flex-wrap: wrap;
  }
`
const Container = styled('div')`
  &.nowrap {
    white-space: nowrap;
    margin-left: 15px;
  }
  p {
    font-size: 16px;
    margin-bottom: 5px;
  }
  a {
    cursor: pointer;
  }
`

export default ({ booking }) => {
  const [showModal, setShowModal] = useState(false)

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const getFreeCancelRule = (cancellationRules) => {
    return cancellationRules.find((rule) => rule.amount === 0)
  }

  const isFreeOfCancelCharges = () => {
    let cancellationRules = booking.products[0].cancellationRules
    if (cancellationRules) {
      const freeCancellationRule = cancellationRules.find((rule) => rule.amount === 0)
      
      if (!freeCancellationRule) {
        return false
      }
      let freeDate = moment(freeCancellationRule.to.replace('Z', '')).subtract(5, 'd')

      if (moment().isBefore(freeDate)) {
        return true
      }
    }
    return false
  }

  const getTripsCancellationText = () => {
    const cancellationRules = booking.products[0].cancellationRules
    const firstStep = cancellationRules[0];
    const secondStep =  cancellationRules[1];
    return textBuilder(
        getText('accommodationOnly', 'cancelTextStandardRate'),
          moment(firstStep.to).format('D MMMM YYYY'),
          moment(firstStep.to).format('HH:mm'),
          <LocalizedCurrency value={Math.ceil(firstStep.amount)} />,
          moment(secondStep.to).format('D MMMM YYYY'),
          moment(secondStep.to).format('HH:mm'),
          <LocalizedCurrency value={Math.ceil(secondStep.amount)} />)
  }

  const getCancellationText = () => {
    const sourceSystem = booking.products[0].productId && booking.products[0].productId.startsWith('A') ? 'TRIPS' : 'LEGACY';
    if(sourceSystem === 'TRIPS' && booking.products[0].cancellationRules && booking.products[0].cancellationRules.length === 3) {
      return getTripsCancellationText();
    }
    const cancellationRules = booking.products[0].cancellationRules
    if (cancellationRules) {
      let freeCancelRule = getFreeCancelRule(cancellationRules)
      if (!freeCancelRule) {
        if (cancellationRules.length === 2) {
          let cancellationCost = cancellationRules[0].amount
          let cancellationDate = moment(cancellationRules[1].to.replace('Z', ''))
          return textBuilder(
            getText('accommodationOnly', 'cancelNoRefund'),
            cancellationDate.format('HH:mm'),
            cancellationDate.format('D MMMM YYYY'),
            <LocalizedCurrency value={Math.ceil(cancellationCost)} />
          )
        } else if(cancellationRules.length === 1) {
          return getText('accommodationOnly', 'cancelNotRefundable')
        }
      } else { 

        let freeDate = moment(freeCancelRule.to.replace('Z', ''))

        if (cancellationRules.length === 2) {
          let cancellationCost = cancellationRules[1].amount
          return textBuilder(getText('accommodationOnly', 'cancelTextOneStep'), freeDate.format('HH:mm'), freeDate.format('D MMMM YYYY'), <LocalizedCurrency value={Math.ceil(cancellationCost)} />)
        } else if (cancellationRules.length === 3) {
          let stepTwoRule = cancellationRules[1]
          let stepTwoDate = moment(stepTwoRule.to.replace('Z', ''))
          return textBuilder(
            getText('accommodationOnly', 'cancelTextTwoSteps'),
            freeDate.format('HH:mm'),
            freeDate.format('D MMMM YYYY'),
            stepTwoDate.format('HH:mm'),
            stepTwoDate.format('D MMMM YYYY'),
            <LocalizedCurrency value={Math.ceil(stepTwoRule.amount)} />
          )
        } else {
          return textBuilder(getText('accommodationOnly', 'cancelTextFullFlexRate'), freeDate.format('D MMMM YYYY'))
        }
      }
    }
    return ''
  }

  const showContactInfo = () => {
    return booking.products[0] && booking.products[0].hotelContact
  }

  const renderHotelInfoModal = () => {
    return (
      <Modal open={showModal} width={'650'} onClose={handleCloseModal}>
        <HotelContactDetails product={booking.products[0]} />
      </Modal>
    )
  }

  return (
    <Fragment>
      {showModal && renderHotelInfoModal()}
      <Flex>
        <Container className="hotel-info">
          <p>
            {textBuilder(
              getText('accommodationOnly', 'contactHotel'),
              showContactInfo() ? <a onClick={handleOpenModal}>{getText('accommodationOnly', 'hotel')}</a> : getText('accommodationOnly', 'hotel')
            )}
          </p>
          <p>{getCancellationText()}</p>
          {!isFreeOfCancelCharges() && (
            <p> {getText('accommodationOnly', 'howToCancel')}</p>
          )}
        </Container>
        <Container className="nowrap">
          <p>
            {getText('accommodationOnly', 'hotelRef')} <strong>{booking.products[0].externalBookingReference}</strong>
          </p>
          <p>
            {getText('accommodationOnly', 'totalPrice')}{' '}
            <strong>
              <LocalizedCurrency value={Math.ceil(booking.priceInfo.totalPrice)} />
            </strong>
          </p>
          {booking.priceInfo.remainingAmount > 0 && (
            <p>
              {getText('accommodationOnly', 'remainingAmount')}{' '}
              <strong>
                <LocalizedCurrency value={Math.ceil(booking.priceInfo.remainingAmount)} />
              </strong>
            </p>
          )}
        </Container>
      </Flex>
    </Fragment>
  )
}
